import {Locale} from '@aboutyou/config';
import {useIsRTL} from '@aboutyou/i18n';
import React from 'react';
import styled, {css} from 'styled-components';
import {VipLogo} from './VipLogo';
import {WoohooCampaignLogo} from './WoohooCampaignLogo';
import {Fade} from '@aboutyou/transitions';
import {mobileOnly, desktopAndUp} from '../../../../constants/customMedia';

export interface SpecialLogoOptions {
  className?: string;
  isVip: boolean;
  vipLandingPageUrl: string;
  woohooCampaign?: {isCampaignLive: boolean; locale: Locale};
  BASCampaignHeaderLogoComponent: React.ReactNode | null;
}

export const SpecialLogo: React.FC<SpecialLogoOptions> = ({
  className,
  isVip,
  vipLandingPageUrl,
  woohooCampaign,
  BASCampaignHeaderLogoComponent,
}) => {
  const isRTL = useIsRTL();

  if (!woohooCampaign && !BASCampaignHeaderLogoComponent && !isVip) {
    return null;
  }

  return (
    <Wrapper
      className={className}
      $isRTL={isRTL}
      $isBASComponent={Boolean(BASCampaignHeaderLogoComponent)}
    >
      {woohooCampaign && <WoohooCampaignLogo locale={woohooCampaign?.locale} />}

      <Fade mounted={isVip} duration={500} delay={{mount: 1300, unmount: 0}}>
        <VipWrapper>
          <VipLogo dataTestId="vipLogo" vipLandingPageUrl={vipLandingPageUrl} />
        </VipWrapper>
      </Fade>

      {BASCampaignHeaderLogoComponent ?? null}
    </Wrapper>
  );
};

const VipWrapper = styled.span`
  opacity: 0;
  padding: 0 4px;
  height: 30px;
`;

export const Wrapper = styled.div<{$isRTL: boolean; $isBASComponent: boolean}>`
  display: flex;
  align-items: center;
  width: max-content;
  height: 100%;

  ${({$isBASComponent}) =>
    $isBASComponent &&
    mobileOnly(css`
      flex-basis: 50%;
    `)}

  ${({$isRTL}) => {
    if ($isRTL) {
      return css`
        ${desktopAndUp(css`
          margin-right: unset;
        `)}
      `;
    }

    return css`
      ${desktopAndUp(css`
        margin-left: unset;
      `)}
    `;
  }};
`;
